'use client';

import { c as _c } from "react/compiler-runtime";
import { useTranslations } from 'next-intl';
import type { InputHTMLAttributes, ReactNode } from 'react';
import { useFormContext } from 'react-hook-form';
import { AppFormDescription } from '@/components/forms/AppFormDescription';
import { ComboboxArrow } from '@/components/icons/social/ComboboxArrow';
import { Paragraph } from '@/components/typography/Paragraph';
import { Button } from '@/components/ui/button';
import { Command, CommandEmpty, CommandGroup, CommandItem, CommandList } from '@/components/ui/command';
import { FormControl, FormField, FormItem, FormMessage } from '@/components/ui/form';
import { Popover, PopoverContent, PopoverTrigger } from '@/components/ui/popover';
import { cn } from '@/lib/styles';
type Props = {
  name: string;
  values: {
    value: string;
    label: string;
  }[];
  noDataMessage?: string;
  placeholder?: string;
  label?: ReactNode;
  description?: ReactNode;
  containerClassName?: string;
  fieldClassName?: string;
  popoverClassName?: string;
  required?: boolean;
} & Omit<InputHTMLAttributes<HTMLInputElement>, 'className'>;
export function AppCombobox(t0) {
  const $ = _c(13);
  const {
    name,
    values,
    noDataMessage,
    placeholder,
    description,
    containerClassName,
    fieldClassName,
    popoverClassName
  } = t0;
  const t = useTranslations("AppCombobox");
  const {
    control
  } = useFormContext();
  const toggleValue = _temp;
  let t1;
  if ($[0] !== containerClassName || $[1] !== description || $[2] !== fieldClassName || $[3] !== noDataMessage || $[4] !== placeholder || $[5] !== popoverClassName || $[6] !== t || $[7] !== values) {
    t1 = t2 => {
      const {
        field,
        fieldState
      } = t2;
      return <FormItem className={cn(containerClassName)}><Popover><PopoverTrigger asChild={true}><FormControl><Button variant="none" size="none" aria-expanded={field.value?.length > 0} className={cn("w-[180px] bg-white justify-between overflow-hidden text-ellipsis border border-neutral-light-600 rounded-sm p-3", fieldClassName, fieldState.invalid && "border-system-critical")}><Paragraph fontSize="bodyRegularMedium" className="flex justify-between w-full items-center">{field.value?.length > 0 ? t("selected", {
                    count: field.value.length
                  }) : placeholder || t("placeholder")}<ComboboxArrow /></Paragraph></Button></FormControl></PopoverTrigger><PopoverContent className={cn("w-[180px] p-0 z-10", popoverClassName)} side="bottom"><Command><CommandList><CommandEmpty>{noDataMessage || t("noDataMessage")}</CommandEmpty><CommandGroup>{values.map(item => <CommandItem key={item.value} value={item.value} onSelect={() => field.onChange(toggleValue(item.value, field.value ?? []))} active={field.value?.includes(item.value)}>{item.label}</CommandItem>)}</CommandGroup>{(field.value?.length ?? 0) > 0 && <CommandItem value="__clear_all__" onSelect={() => field.onChange([])} className="text-destructive pl-10" hideCheckIcon={true}>{t("clearSelection")}</CommandItem>}</CommandList></Command></PopoverContent></Popover><AppFormDescription description={description} /><FormMessage /></FormItem>;
    };
    $[0] = containerClassName;
    $[1] = description;
    $[2] = fieldClassName;
    $[3] = noDataMessage;
    $[4] = placeholder;
    $[5] = popoverClassName;
    $[6] = t;
    $[7] = values;
    $[8] = t1;
  } else {
    t1 = $[8];
  }
  let t2;
  if ($[9] !== control || $[10] !== name || $[11] !== t1) {
    t2 = <FormField control={control} name={name} render={t1} />;
    $[9] = control;
    $[10] = name;
    $[11] = t1;
    $[12] = t2;
  } else {
    t2 = $[12];
  }
  return t2;
}
function _temp(current, selected) {
  return selected.includes(current) ? selected.filter(v => v !== current) : [...selected, current];
}